import { render, staticRenderFns } from "./NoticeBar.vue?vue&type=template&id=035130ba&scoped=true&"
import script from "./NoticeBar.vue?vue&type=script&lang=js&"
export * from "./NoticeBar.vue?vue&type=script&lang=js&"
import style0 from "./NoticeBar.vue?vue&type=style&index=0&id=035130ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035130ba",
  null
  
)

export default component.exports